import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=37058a82&scoped=true"
import script from "./CountDown.vue?vue&type=script&lang=js"
export * from "./CountDown.vue?vue&type=script&lang=js"
import style0 from "./CountDown.vue?vue&type=style&index=0&id=37058a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37058a82",
  null
  
)

export default component.exports